// Tiny pub/sub so any component can trigger the full-screen flash message
// (fade in -> hold ~3s -> fade out), e.g. license result or contact email.
const listeners = new Set();

export const onFlash = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const flash = (message, tone = "green") => {
  listeners.forEach((fn) => fn({ message, tone }));
};
